import { Address } from '../../../../types/Common';
import { SmtFile } from '../../../../types/Form';
// ENUMS

export interface Accident {
  date: string;
  at_fault: boolean;
}

export enum Loan {
  CASH_CREDITS = 'CASH_CREDITS',
  FIXED_ADVANCES = 'FIXED_ADVANCES',
  BRIDGING_CREDIT = 'BRIDGING_CREDIT',
  WORKING_CAPITAL_CREDITS = 'WORKING_CAPITAL_CREDITS',
  INVESTMENT_CREDITS = 'INVESTMENT_CREDITS',
}

export enum Lease {
  FINANCIAL = 'FINANCIAL',
  OPERATIONAL = 'OPERATIONAL',
  SALE_AND_LEASEBACK = 'SALE_AND_LEASEBACK ',
}

export enum LegalForm {
  BV = 'BV',
  NV = 'NV',
  SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
  VOF = 'VOF',
  PARTNERSHIP = 'PARTNERSHIP',
  ASSOCIATION = 'ASSOCIATION',
  FOUNDATION = 'FOUNDATION',
  OTHER = 'OTHER',

  // Currently disabled as not supported yet
  // CV = 'CV',
  // JOINT_OWNERSHIP = 'JOINT_OWNERSHIP',
  // MARITAL_PROPERTY = 'MARITAL_PROPERTY',
  // NONE = 'NONE',
  // IVZW = 'IVZW',
  // VZW = 'VZW',
  // ACTUAL = 'ACTUAL',
}

// TYPES

export interface CompanyLoan {
  type: Loan;
  duration: number;
  amount: number;
  purpose: string;
  lender_details: string;
}

export interface CompanyLease {
  type: Lease;
  duration: number;
  amount: number;
  purpose: string;
  leasing_company: string;
}

export interface CompanyInvestment {
  type: string;
  duration: number;
  amount: number;
  purpose: Loan;
}

export interface UnitObject {
  value: number;
  unit: string;
}

export interface Claim {
  circumstances: string;
  claim_date: string;
  expenses: number;
  has_certificate: boolean;
  documents?: SmtFile[];
}

export interface BuildingObject {
  index: number;
  address: Address;
}

export interface Company {
  cbe: string;
  name: string;
  legal_form: LegalForm;
  nace_code: NaceCode[];
  address: Address;
}

export interface NaceCode {
  code: string;
  label: string;
  level: string;
  parent_code: string;
  section_code: string;
}

export type NaceCodeList = NaceCode & {
  departments?: NaceCode[];
  groups?: NaceCode[];
  classes?: NaceCode[];
  subclasses?: NaceCode[];
};

export interface GbiCode {
  code: string;
  label: string;
}

export interface GbiCodeSearchResult {
  gbi_id: string;
  description: string;
  sbi25_codes: string[];
}
